import { AssessmentAdministrator } from './AssessmentAdministrator.model';
import { ModuleAccessRUMConfiguration } from './ModuleAccess';

// this maps to the AccountStatus enum in Core
export enum AccountStatus {
    Unknown = 0,
    NoTrial = 1,
    HireTrial = 2,
    Prospect = 3
}

export enum PI2UpgradeStatus {
    Unknown = 'UNKNOWN',
    NotYetUpgraded = 'NOT_YET_UPGRADED',
    PreUpgradePeriod = 'PREUPGRADE_PERIOD',
    UpgradeRequested = 'UPGRADE_REQUESTED',
    UpgradeInProgress = 'UPGRADE_IN_PROGRESS',
    UpgradeComplete = 'UPGRADE_COMPLETE',
    UpgradeFailure = 'UPGRADE_FAILURE',
    UpgradeFailureRollback = 'UPGRADE_FAILURE_ROLLBACK',
    NotUpgradeEligible = 'NOT_UPGRADE_ELIGIBLE',
    DataCorrectionComplete = 'DATA_CORRECTION_COMPLETE'
}

// This is duplicated with AccountConfigServer revealing an inefficiency
// in our data modelling
export type AccountConfig = {
    assessmentSiteLoginUrl: string;
    behavioralAssessmentExpirationInDays: number;
    cognitiveAssessmentExpirationInDays: number;
    folderId: string;
    asssessmentSiteLoginUrl: string;
    cognitiveSiteLoginUrl: string;
    jobAsssessmentSiteLoginUrl: string;
    hasCognitiveAccessCompanyLevel: boolean;
    companyAllowsSwitchSite: boolean;
    companyUrlSegment: string;
    hasHire: boolean;
    hasInspire: boolean;
    hasEngage: boolean;
    hasStrategy: boolean;
    isOnboardingEnabled: boolean;
    accountStatus: AccountStatus;
    isHouseClient: boolean;
    partnerCompanyName: string;
    partnerContactFirstName: string;
    partnerContactLastName: string;
    partnerContactEmail: string;
    partnerContactPhone: string;
    companyCreateDate: Date;
    currentApiCompanyId: string;
    isGoToMarketClient: boolean;
    hasTeamDiscovery: boolean;
    isDirectClient: boolean;
    piVersion: number;
    hasAtsAccess: boolean;
    hasApiAccess: boolean;
    hasHrisAccess: boolean;
    pi2UpgradeStatus: PI2UpgradeStatus;
    isBornInPI2: boolean;
};

export type UserProfile = {
    userGuid: string;
    firstName: string;
    lastName: string;
    email: string;
    defaultFolderGuid: string;
    defaultFolderPath: string;
    defaultLanguageCode: string;
    defaultTimeZoneIdentifier: string;
    hasAcknowledgedCogBestPractices: boolean;
    hasAcknowledgedWelcomeGuideCta: boolean;
    isUsingBetaSite: boolean;
    settings: any;
};

export type InitData = {
    accessibleFeaturesList: string[];
    administrator: AssessmentAdministrator;
    accountConfig: AccountConfig;
    userProfile: UserProfile;
    softwareModuleAccessConfig?: {
        Hire?: ModuleAccessRUMConfiguration;
        Design?: ModuleAccessRUMConfiguration;
        Diagnose?: ModuleAccessRUMConfiguration;
        Inspire?: ModuleAccessRUMConfiguration;
    };
};

export type CompanyEmailDomains = {
    allowList: string[];
    isAllowNonDomainEnabled?: boolean;
};

export type PendoMetadata = {
    visitor: {
        id: string;
        loggedInCompanyId: string;
        isBornInPI2: boolean;
        isLoggedIntoDefaultCompany: boolean;
        isThirdPartyUser: boolean;
        email: string;
        firstName: string;
        lastName: string;
        role: string;
        languageLocale: string;
        features?: string;
        softwareVersion: string;
        defaultCompanyId: string;
        browserWidth: number;
        browserHeight: number;
        browserResolution: string;
        partnerCompanyName: string;
        partnerContactFirstName: string;
        partnerContactLastName: string;
        partnerContactEmail: string;
        partnerContactPhone: string;
    };
    account: {
        id: string;
        name: string;
        accountStatus: AccountStatus;
        pi2UpgradeStatus: PI2UpgradeStatus;
        piVersion: number;
        isBornInPI2: boolean;
    };
};
